<template>
  <div class="home-container">
    <!-- 顶部导航栏 -->
    <nav class="nav-bar">
      <div class="nav-logo">Zzll</div>
      <ul class="nav-list">
        <li class="nav-item" @click="scrollToSection('home')">首页</li>
        <!-- <li class="nav-item" @click="scrollToSection('about')">关于我</li> -->
        <!-- <li class="nav-item" @click="scrollToSection('skill')">技能</li> -->
        <!-- <li class="nav-item" @click="scrollToSection('project')">项目作品</li> -->
        <li class="nav-item" @click="scrollToSection('message')">留言</li>
      </ul>
    </nav>

    <!-- 首页横幅区域 -->
    <section class="home-section" id="home">
      <div class="home-content">
        <img
          src="https://img.cdn1.vip/i/694a8528291fc_1766491432.webp"
          alt="Zzll头像"
          class="home-avatar"
        />
        <h1 class="home-name">Zzll</h1>
      </div>
    </section>

    <!-- 留言区域 -->
    <section class="section message-section" id="message">
      <div class="section-title">在线留言</div>
      <div class="message-box">
        <input
          type="text"
          v-model="msgName"
          placeholder="请输入你的昵称"
          class="msg-input"
        />
        <textarea
          v-model="msgContent"
          placeholder="请输入留言内容"
          class="msg-textarea"
        ></textarea>
        <button class="msg-btn" @click="submitMsg">提交留言</button>
      </div>
    </section>

    <!-- 底部版权 -->
    <footer class="footer">
      <p>Copyright © 2026 Zzll All Rights Reserved</p>
    </footer>
  </div>
</template>

<script setup>
import { ref } from "vue";

// 留言数据
const msgName = ref("");
const msgContent = ref("");

// 平滑滚动
const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

// 提交留言
const submitMsg = () => {
  if (!msgName.value || !msgContent.value) {
    alert("请完善昵称和留言内容");
    return;
  }
  alert("留言提交成功！");
  msgName.value = "";
  msgContent.value = "";
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

body {
  background: #ffffff;
  color: #333;
}

/* 导航栏 */
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 70px;
  background: #ffffff;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 80px;
  z-index: 999;
}

.nav-logo {
  font-size: 22px;
  font-weight: 600;
  color: #222;
  letter-spacing: 2px;
}

.nav-list {
  display: flex;
  gap: 40px;
  list-style: none;
}

.nav-item {
  font-size: 15px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
}

.nav-item:hover {
  color: #222;
}

/* 首页区域 */
.home-section {
  width: 100%;
  height: 100vh;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 70px;
}

.home-content {
  text-align: center;
}

.home-avatar {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #f5f5f5;
  margin-bottom: 30px;
  transition: transform 0.3s ease;
}

.home-avatar:hover {
  transform: scale(1.05);
}

.home-name {
  font-size: 40px;
  font-weight: 500;
  color: #222;
  margin-bottom: 15px;
  letter-spacing: 3px;
}

.home-desc {
  font-size: 16px;
  color: #888;
  margin-bottom: 40px;
}

.home-btn {
  display: inline-block;
  padding: 12px 36px;
  border: 1px solid #ddd;
  border-radius: 30px;
  font-size: 15px;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
}

.home-btn:hover {
  background: #f8f8f8;
  border-color: #ccc;
}

/* 通用区块样式 */
.section {
  width: 100%;
  padding: 100px 80px;
  background: #ffffff;
}

.section-title {
  font-size: 28px;
  color: #222;
  text-align: center;
  margin-bottom: 60px;
  position: relative;
}

.section-title::after {
  content: "";
  display: block;
  width: 60px;
  height: 2px;
  background: #eee;
  margin: 12px auto 0;
}

/* 关于我 */
.about-content {
  max-width: 800px;
  margin: 0 auto;
}

.about-text p {
  font-size: 16px;
  color: #666;
  line-height: 2;
  margin-bottom: 20px;
  text-indent: 2em;
}

/* 技能区域 */
.skill-list {
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.skill-item {
  padding: 30px;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.skill-item:hover {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.04);
  border-color: #e8e8e8;
}

.skill-name {
  font-size: 18px;
  color: #222;
  margin-bottom: 15px;
  font-weight: 500;
}

.skill-desc {
  font-size: 15px;
  color: #777;
  line-height: 1.8;
}

/* 项目区域 */
.project-list {
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.project-item {
  padding: 30px;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.project-item:hover {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.04);
}

.project-name {
  font-size: 18px;
  color: #222;
  margin-bottom: 15px;
  font-weight: 500;
}

.project-desc {
  font-size: 15px;
  color: #777;
  line-height: 1.8;
}

/* 留言区域 */
.message-box {
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.msg-input {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  border: 1px solid #eee;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  transition: border 0.3s ease;
}

.msg-input:focus {
  border-color: #ccc;
}

.msg-textarea {
  width: 100%;
  height: 120px;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  resize: none;
  transition: border 0.3s ease;
}

.msg-textarea:focus {
  border-color: #ccc;
}

.msg-btn {
  width: 140px;
  height: 46px;
  border: none;
  background: #f5f5f5;
  border-radius: 8px;
  font-size: 15px;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 auto;
}

.msg-btn:hover {
  background: #eeeeee;
}

/* 底部 */
.footer {
  width: 100%;
  height: 80px;
  line-height: 80px;
  text-align: center;
  font-size: 14px;
  color: #999;
  background: #ffffff;
  border-top: 1px solid #f5f5f5;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .nav-bar {
    padding: 0 20px;
  }
  .nav-list {
    gap: 15px;
  }
  .section {
    padding: 60px 20px;
  }
  .skill-list,
  .project-list {
    grid-template-columns: 1fr;
  }
  .home-name {
    font-size: 32px;
  }
}
</style>
